import React from 'react';
import { Brodcrumb } from '../../components/ui/UtilsLayout';
import { iconsPath, imagePath, videoPath } from '../../utils/imagePath';
import { BackgroundWithCurve, CaseStudiesImageCard, CaseStudyHeading, Section } from '../../utils/CaseStudiesComponents';

// CaseStudy Component
const Creme21Web = () => {
  return (
    <div className="flex justify-center px-5 md:px-10 lg:px-16  items-center gap-6 text-white pb-16 relative">
      <BackgroundWithCurve />
      <div className="max-w-[1200px] w-full  pt-24 md:pt-32 relative z-10">
        {/* Breadcrumb Navigation */}
        <Brodcrumb
          data={{
            name: 'Creme 21',
            item: [
              { name: 'Industry Use Cases', path: '/all-industries' },
              {
                name: 'Retail & E-Commerce',
                path: '/industries/retail-ecommerce',
              },
            ],
          }}
        />

        <div className="my-10 flex flex-col w-full gap-10">
          {/* Header Section with Logo */}
          <div className="flex gap-3 md:gap-5 lg:gap-10">
            <div className="flex justify-center items-center  bg-white shadow-[0px_0px_4px_1px_rgba(0,0,0,0.25)] h-20 w-24 md:h-20 md:w-20 lg:h-24 lg:w-24 rounded-lg">
              {/* Company Logo */}
              {imagePath?.Creme21Logo ? (
                <img
                  className="h-14 w-14 md:h-12 md:w-12 lg:h-16 lg:w-16 object-contain"
                  src={imagePath?.Creme21Logo}
                  alt="Creme 21 Logo"
                />
              ) : (
                <span className="text-gray-400 text-xs">No Logo</span>
              )}
            </div>

            {/* Case Study Heading */}
            <div className="flex flex-col gap-2 md:gap-5 justify-center">
              <CaseStudyHeading
                title="Creme 21"
                desc="Product Campaign Using Instant Apps"
              />
            </div>
          </div>

          <div className="relative">
            {/* Video Container - Responsive aspect ratio */}
            <div className="relative w-full aspect-video bg-[#31333A] shadow-[0px_0px_21px_4px_rgba(0,0,0,0.25)] flex justify-center items-center ">
              {/* Play Icon */}
              {videoPath?.AmericanaVideo && (
                <video
                  src={videoPath.Creme21Video}
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="w-full h-full object-cover rounded-lg"
                >
                  Your browser does not support the video tag.
                </video>
              )}

              {/* {iconsPath?.QRIcon && (
                <div className="absolute -top-4 -right-4 md:-top-6 md:-right-6 lg:-top-8 lg:-right-8 bg-[#fff] p-2 md:p-3 rounded-[10px]">
                  <img
                    src={iconsPath.QRIcon}
                    alt="QR Code"
                    className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24"
                  />
                </div>
              )} */}
            </div>
          </div>

          {/* Case Study Description */}
          <Section
            title="Overview"
            subtitle="Instant Apps based AR experience to campaign product"
            content="Objective of this project is to develop instant apps-based AR experience designed for users to
            understand and interact with the Global organization’s product without having to change the
            end-user’s behavior. It is intended to showcase the product’s features and benefits in a short
            window of time."
          />

          <Section
            title="Execution"
            content={[
              'This customer selected the Spatial Grid platform to develop instant apps (namely APPClips foriOS and InstaApps for Android) AR experience triggered through a QR code. When the userscans the QR code an AI generated persona will appear describing features of the product. The customer was able to leverage AI plug-ins available in the Spatial Grid platform to includeadditional animations required to provide an engaging experience to the end-user.',
              'In this application for the Creme21 customer, the platform was leveraged to deliver an Instant Apps–based AR experience, allowing users to engage instantly without downloads. The solutioncaptured detailed insights into user interactions, enabling a deeper understanding of engagementpatterns. AI-driven animations and simulations were used to enhance the created avatars, addinga layer of personalization and realism. Additionally, advanced platform features supported the creation of lifelike scenes and environments, resulting in an immersive and visually compelling AR experience aligned with the brand.',
            ]}
          />

          {/* Image Grid Section */}
          <div className="flex flex-col gap-3">
            <div className="flex md:flex-row flex-col gap-10 md:gap-20 w-full">
              <CaseStudiesImageCard
                image={imagePath?.Creme21First}
                title="AR Experience Interface"
              />
              <CaseStudiesImageCard
                image={imagePath?.Creme21Second}
                title="AI-Led AR Product Showcase"
              />
            </div>
          </div>

          {/* Impact Section */}
          <div className="flex flex-col gap-3">
            <Section
              title="Impact"
              subtitle="Increased footfall on products in store"
              content="Development of the project from concept to deployment was completed in 8 days
reducing the TCO significantly and improving the time to market. This timeline also included the
process to publish the instant apps in iOS and Android application stores respectively."
            />
          </div>
        </div>
      </div>
    </div>
  );
};
<CaseStudyHeading />;
<CaseStudiesImageCard />;

export default Creme21Web;
